'use client';

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './BusinessGameFaq.module.scss';
import { faqItems } from './business-game.content';

export default function BusinessGameFaq() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>
            Частые <span className={styles.highlight}>вопросы</span>
          </h2>
          <p className={styles.sectionSubtitle}>
            Коротко о формате участия, регистрации и ожиданиях от деловой игры.
          </p>
        </div>

        <div className={styles.faqList}>
          {faqItems.map((item, index) => {
            const isOpen = openFaqIndex === index;
            const answerId = `business-game-faq-answer-${index}`;
            const questionId = `business-game-faq-question-${index}`;

            return (
              <div key={item.question} className={`${styles.faqItem} ${isOpen ? styles.open : ''}`}>
                <button
                  id={questionId}
                  type="button"
                  className={styles.faqQuestion}
                  onClick={() => toggleFaq(index)}
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                >
                  <span className={styles.questionText}>{item.question}</span>
                  <span className={styles.chevron} aria-hidden="true">
                    <ChevronDown size={20} />
                  </span>
                </button>

                <div
                  id={answerId}
                  role="region"
                  aria-labelledby={questionId}
                  className={`${styles.faqAnswer} ${isOpen ? styles.visible : ''}`}
                >
                  <div className={styles.answerContent}>{item.answer}</div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
